export default {
  404: 'Dispositivo no encontrado.',
  427: 'Este dispositivo ya se encuentra guardado en el sistema.',
  449: 'La etiqueta no existe',
};
